import { LogOut } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { useT } from '@/lib/i18n';

export function UserMenu() {
  const { user, signOut } = useAuth();
  const t = useT();
  if (!user) return null;

  const initial = (user.name ?? user.email).charAt(0).toUpperCase();

  return (
    <div className="flex items-center gap-2.5">
      {user.picture ? (
        <img
          src={user.picture}
          alt=""
          className="size-7 rounded-full"
          referrerPolicy="no-referrer"
        />
      ) : (
        <div className="flex size-7 items-center justify-center rounded-full bg-surface-3 text-label font-semibold text-fg-muted">
          {initial}
        </div>
      )}
      <div className="min-w-0 flex-1 leading-tight">
        <div className="truncate text-label text-fg">{user.name ?? user.email}</div>
        {user.name ? <div className="truncate text-micro text-fg-subtle">{user.email}</div> : null}
      </div>
      <button
        type="button"
        onClick={signOut}
        title={t.signOut()}
        aria-label={t.signOut()}
        className="grid min-h-[40px] min-w-[40px] shrink-0 place-items-center rounded-md p-2.5 text-fg-subtle transition-fast hover:bg-surface-2 hover:text-fg sm:min-h-0 sm:min-w-0 sm:p-1.5"
      >
        <LogOut className="size-4" aria-hidden />
      </button>
    </div>
  );
}
